export enum ToolCategory {
  COMMUNICATION = "communication",
  DATA_MANAGEMENT = "data_management",
  SYSTEM = "system",
  COLLABORATION = "collaboration",
  KNOWLEDGE = "knowledge",
  DEVELOPMENT = "development",
  SESSION = "session",
  INTEGRATION = "integration",
  UTILITY = "utility"
}

export enum ToolPermission {
  BASIC = "basic",
  ELEVATED = "elevated",
  ADMIN = "admin",
  SYSTEM = "system"
}

export enum ToolStatus {
  DEVELOPMENT = "development",
  BETA = "beta",
  STABLE = "stable",
  DEPRECATED = "deprecated",
  OFFLINE = "offline",
  EXPERIMENTAL = "experimental"
}

export interface ToolVersion {
  major: number;
  minor: number;
  patch: number;
}

export interface ToolDocumentation {
  summary: string;
  description: string;
  usage_notes?: string;
  examples: any[];
  limitations?: string;
  see_also: string[];
}

export interface TestScenario {
  name: string;
  description: string;
  parameters: Record<string, any>;
}

export interface ToolExecuteResult {
  success: boolean;
  result: any;
  error: string | null;
  execution_time: number;
  cached: boolean;
  tool_name: string;
  tool_status: string;
  standalone_tier: string;
  warning?: string;
}

export interface ToolMetadata {
  name: string;
  category: ToolCategory;
  permission_level: ToolPermission;
  is_stateful: boolean;
  use_cache: boolean;
  tags: string[];
  documentation: ToolDocumentation;
  // New fields
  status?: ToolStatus;
  version?: ToolVersion;
  min_api_version?: string;
  created_at?: string;
  updated_at?: string;
  maintainer?: string;
  offline_reason?: string;
  standalone_tier?: string;
  test_scenarios?: TestScenario[];
  default_for_personas?: boolean;
}

export interface Tool {
  name: string;
  metadata: ToolMetadata;
  schema: any;
}

export interface CategoryCount {
  name: string;
  count: number;
}

export interface TagCount {
  name: string;
  count: number;
}
